import React, { useState,useEffect } from 'react';
import { FaAddressCard, FaUser, FaCheckCircle, FaFileAlt } from 'react-icons/fa'; // For Icons
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import axios from 'axios';


const MultiStepForm = () => {

  const BaseUrl = process.env.REACT_APP_API;


  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [ClientData, setClientData] = useState([]);
  const [signatureURL, setSignatureURL] = useState('');



  const steps = [
    { name: 'Basic Info', icon: <FaAddressCard onClick={() => setCurrentStep(0)} /> },
    { name: 'Contact Info', icon: <FaUser onClick={() => setCurrentStep(1)} /> },
    { name: 'KYC Documents', icon: <FaFileAlt onClick={() => setCurrentStep(2)} /> },
    { name: 'Declaration', icon: <FaCheckCircle onClick={() => setCurrentStep(3)} /> },
  ];
  const navigate = useNavigate();
 
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) {
          navigate('/');
          throw new Error("JWT token not found in local storage");
        }

        // Verify token using your backend endpoint
        const tokenVerificationResponse = await axios.post(
          `${BaseUrl}/validate-token`,
          { token: jwtToken }
        );

        if (!tokenVerificationResponse.data.valid) {
          throw new Error("Token validation failed or expired");
        }

      
        const response = await axios.get(`${BaseUrl}/getIndividualInfo`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setClientData(response.data);
       
       
      } catch (error) {
        console.error(error.message || "Error fetching company data");
      }
    };

    fetchCompanyData();
  }, [BaseUrl]);



  // Handle Next Button Click
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle Previous Button Click
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    navigate("/dashboard");
  };

  const formatDateToIST = (dateString) => {
    if (!dateString) return '';
  
    const date = new Date(dateString);
    
    const istOffset = 5.5 * 60 * 60 * 1000; 
    const localDate = new Date(date.getTime() + istOffset);
  
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchSignature = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/individual-digital-signature/${ClientData[0]?.digital_signature}`, {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = URL.createObjectURL(blob);
        setSignatureURL(url);
      } catch (error) {
        console.error('Error fetching digital signature:', error);
      }
    };

    if (ClientData[0]?.digital_signature) {
      fetchSignature();
    }
  }, [ClientData[0]?.digital_signature]);

  return (
    <div id="msform" className="container mt-4 ">
      {/* Progress Bar */}
      <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`text-center ${index <= currentStep ? 'active' : ''}`}
            id={step.name.toLowerCase().replace(' ', '')}
          >
            <div className="step-icon mb-1">{step.icon}</div>
            <span>{step.name}</span>
          </li>
        ))}
      </ul>


  {/* Basic INFO Fieldsets */}
     <Container className="mt-5" >
        <Form>
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 0 ? "block" : "none",
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
              textAlign:"left"
            }}
           
          >
            <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              Personal Information
            </h6>
            <hr
              style={{
                margin:"5px",
                border: "1px solid #748292",
                width: "100%",
              }}
            />

           
            <div className="row mb-3" >
              <label className="col-md-3 col-form-label text-start ">Full Legal Name</label>
              <div className="col-md-9" >
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your full legal name"
                  value={ClientData[0]?.full_legal_name ? ClientData[0]?.full_legal_name: 'N/A'}
                  readOnly
                />
              </div>
            </div>

          
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start "> Other Name</label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter any other name"
                  value={ClientData[0]?.other_names_used ? ClientData[0]?.other_names_used: 'N/A'}
                  readOnly
                />
              </div>
            </div>

           
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Date of Birth
              </label>
              <div className="col-md-9">
                <input type="date" className="form-control shadow-sm"
                 value={ClientData[0]?.date_of_birth ? formatDateToIST(ClientData[0]?.date_of_birth): 'N/A'}
                 readOnly
                  />
              </div>
            </div>

          
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Place of Birth
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter place of birth"
                  value={ClientData[0]?.place_of_birth ? ClientData[0]?.place_of_birth: 'N/A'}
                  readOnly
                />
              </div>
            </div>

           
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Nationality
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your nationality"
                  value={ClientData[0]?.nationality ? ClientData[0]?.nationality: 'N/A'}
                  readOnly
                />
              </div>
            </div>

            
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Passport Number
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your passport number"
                  value={ClientData[0]?.passport_number ? ClientData[0]?.passport_number: 'N/A'}
                  readOnly
                />
              </div>
            </div>

            {/* Issue and Expiry Date */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Issue Date
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your Issue Date"
                  value={ClientData[0]?.passport_issue_date ? formatDateToIST(ClientData[0]?.passport_issue_date): 'N/A'}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Expiry Date
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your Expiry Date"
                  value={ClientData[0]?.passport_expiry_date ? formatDateToIST(ClientData[0]?.passport_expiry_date): 'N/A'}
                  readOnly
                />
              </div>
            </div>
           
            {/* National ID */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                National ID Number
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your national ID number"
                  value={ClientData[0]?.national_id_number ? ClientData[0]?.national_id_number: 'N/A'}
                  readOnly
                />
              </div>
            </div>

            {/* Place of Passport Issue */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Place of ID Issue
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter place of issue"
                  value={ClientData[0]?.national_id_issue_place ? ClientData[0]?.national_id_issue_place: 'N/A'}
                  readOnly
                />
              </div>
            </div>

             {/* Issue and Expiry Date */}
             <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Issue Date
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your Issue Date"
                  value={ClientData[0]?.national_id_issue_date ? formatDateToIST(ClientData[0]?.national_id_issue_date): 'N/A'}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Expiry Date
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your Expiry Date"
                  value={ClientData[0]?.national_id_expiry_date ? formatDateToIST(ClientData[0]?.national_id_expiry_date): 'N/A'}
                  readOnly
                />
              </div>
            </div>

            {/* Account Type */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Type of Account
              </label>
              <div className="col-md-9">
                <select className="form-control shadow-sm"
                 value={
                  ClientData[0]?.type_of_account
                }
                 disabled
                 readOnly>
                <option value="">Select</option>
                <option value="1">Resident</option>
                <option value="2">Non resident</option>
                </select>
              </div>
            </div>
            
             {/* Nature of Account */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Nature of Account
              </label>
              <div className="col-md-9">
                <select className="form-control shadow-sm" 
                 value={
                  ClientData[0]?.nature_of_account
                }
                disabled
                readOnly>
                <option value="">Select</option>
                <option value="1">Investment in Equities</option>
                <option value="2">Investment in Securities</option>
                <option value="3">Investment in Bonds</option>
                <option value="4">Investment in Commodities</option>
                <option value="5">Investment in Mutual Funds</option>
                <option value="6">Investment in Stocks</option>
                <option value="7">Investment in Digital Assets</option>
                </select>
              </div>
            </div>


             {/* Anticipated Volume */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Anticipated Volume
              </label>
              <div className="col-md-9">
                <select className="form-control shadow-sm" 
                 value={
                  ClientData[0]?.anticipated_volume
                }
                disabled
                readOnly>
                <option value="">Select</option>
                <option value="1">1 - 100,000 USD</option>
                <option value="2">100,000 - 500,000 USD</option>
                <option value="3">500,000 - 1,000,000 USD</option>
                <option value="4">1,000,000 - 10,000,000 USD</option>
                <option value="5">10,000,000 - 50,000,000 USD</option>
                </select>
              </div>
            </div>

            {/* Occupation */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Occupation
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your occupation"
                  value={ClientData[0]?.occupation ? ClientData[0]?.occupation: 'N/A'}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Employer Name
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your Employer Name"
                  value={ClientData[0]?.employer_name ? ClientData[0]?.employer_name: 'N/A'}
                  readOnly
                />
              </div>
            </div>

              {/* Anticipated Volume */}
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Source of Funds
              </label>
              <div className="col-md-9">
                <select className="form-control shadow-sm"
                    value={
                      ClientData[0]?.source_of_funds
                    }
                 disabled
                 readOnly>
                <option value="">Select</option>
                <option value="1">Salary</option>
                <option value="2">Business Activity</option>
                <option value="3">Savings</option>
                <option value="4">Pension</option>
                <option value="5">Inheritance</option>
                <option value="6">Gift</option>
                <option value="7">Bonus</option>
                <option value="8">Indemnity/End of Service Payment</option>
                <option value="9">Return on Investments</option>
                <option value="10">Other</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
                Reason for Opening Account
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the Reason "
                  value={ClientData[0]?.reason_for_opening_account ? ClientData[0]?.reason_for_opening_account: 'N/A'}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              PEP Name
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the PEP Name "
                  value={ClientData[0]?.pep_name ? ClientData[0]?.pep_name: 'N/A'}
                  readOnly
                />
              </div>
            </div>

            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">
              Position Held
              </label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter the Position Held "
                  value={ClientData[0]?.position_held ? ClientData[0]?.position_held: 'N/A'}
                  readOnly
                />
              </div>
            </div>

          </fieldset>

          </Form>

            

       {/* contact info */}
        <fieldset
          style={{
           textAlign:"left",
           display: currentStep === 1 ? "block" : "none"}}
           >
           
          <div  style={{
            margin: "10px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 0px 20px #748292",
            transition: "all 0.5s ease-in-out"}} >
              <h6 className="text-start " style={{ marginBottom: "0.7rem" }}>Contact Info</h6>
              <hr  style={{
                border: "1px solid #748292",
                margin: "5px",
                width: "100%",
              }}/>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">
                Full Permanent Address
              </label>
              <div className="col-md-9">
                <input
                  className="form-control shadow-sm"
                  placeholder="Enter your full permanent address"
                  value={ClientData[0]?.full_permanent_address ? ClientData[0]?.full_permanent_address: 'N/A'}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Telephone *</label>
              <div className="col-md-9">
                <input
                  type="tel"
                  className="form-control shadow-sm"
                  placeholder="Enter your telephone number"
                  value={ClientData[0]?.telephone ? ClientData[0]?.telephone: 'N/A'}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">Fax</label>
              <div className="col-md-9">
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter your fax number (if any)"
                  value={ClientData[0]?.fax ? ClientData[0]?.fax: 'N/A'}
                  readOnly
                />
              </div>
            </div>
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start">E-Mail</label>
              <div className="col-md-9">
                <input
                  type="email"
                  className="form-control shadow-sm"
                  placeholder="Enter your email address"
                  value={ClientData[0]?.email ? ClientData[0]?.email: 'N/A'}
                  readOnly
                />
               
              </div>
            </div>
            
          </div>
        </fieldset>





          {/* KYC Documents */}
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 2 ? "block" : "none",
            }}>
            <div
              style={{
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
             
            >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Document Uploaded
              </h6>
              <hr
                style={{
                  border: "1px solid #748292",
                  margin: "5px",
                  width: "100%",
                }}
              />

              {/* <p className="text-muted text-start mb-4">
                The file size must be under 10 MB and only PDF format is accepted.
              </p> */}

              {/* Passport Copy */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Passport Copy
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    value={ClientData[0]?.passport_copy ? ClientData[0]?.passport_copy: 'N/A'}
                    readOnly
                  />
                </div>
              </div>

              {/* National ID */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  National ID
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    value={ClientData[0]?.national_id ? ClientData[0]?.national_id: 'N/A'}
                    readOnly
                  />
                </div>
              </div>

              {/* Other Document */}
              <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Other Document
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    accept=".pdf"
                    value={ClientData[0]?.other_documents ? ClientData[0]?.other_documents: 'N/A'}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </fieldset>

       <fieldset
            style={{
              textAlign:"left",
              padding: "20px",
              display: currentStep === 3 ? "block" : "none", // Adjust for currentStep
            }}>
            <div
              style={{
                padding: "25px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
              >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Declarations
              </h6>
              <hr
                style={{
                  marginBottom: "0.5rem",
                  width:"100%",
                  border: "1px solid #748292"
                }}/>

          {/* Declaration Text */}
          {/* <div className=" mb-3"
          >
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration1"
            checked={isChecked1}
            onChange={(e) => setIsChecked1(e.target.checked)}
            required/>
          <label className="form-check-label" htmlFor="declaration1">
            I/We confirm that I/we are acting on my/our behalf for the purpose of
            transactions, new accounts or providing any further information required
            by Blue Aster Capital BSC ©.
          </label>
        </div> */}

        {/* <div className=" mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration2"
            checked={isChecked2}
            onChange={(e) => setIsChecked2(e.target.checked)}
            required/>
          <label className="form-check-label" htmlFor="declaration2">
            I/We confirm the information provided above is true, accurate and
            complete. I/we consent to share information with regulators or tax
            authorities where necessary.
          </label>
        </div> */}

        {/* <div className="mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration3"
            checked={isChecked3}
            onChange={(e) => setIsChecked3(e.target.checked)}
            required
          />
          <label className="form-check-label" htmlFor="declaration3">
            I/We agree to notify Blue Aster Capital BSC © within 30 calendar days
            of any change in the provided information.
          </label>
        </div> */}


              {/* Name / Authorised Signatory Name */}
              {/* <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Name / Authorised Signatory Name
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    placeholder="Enter your name"
                    required
                  />
                </div>
              </div> */}

              {/* Digital Signature */}
              {/* <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Digital Signature
                </label>
                <div className="col-md-9">
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      height: "150px",
                      position: "relative",
                    }}>
                    <canvas
                      ref={(canvasRef) => {
                        if (canvasRef) {
                          const ctx = canvasRef.getContext("2d");
                          canvasRef.addEventListener("mousedown", (e) => {
                            ctx.isDrawing = true;
                            ctx.beginPath();
                            ctx.moveTo(e.offsetX, e.offsetY);
                          });

                          canvasRef.addEventListener("mousemove", (e) => {
                            if (ctx.isDrawing) {
                              ctx.lineTo(e.offsetX, e.offsetY);
                              ctx.stroke();
                            }
                          });

                          canvasRef.addEventListener("mouseup", () => {
                            ctx.isDrawing = false;
                          });

                          canvasRef.addEventListener("mouseleave", () => {
                            ctx.isDrawing = false;
                          });
                        }
                      }}
                      width="500"
                      height="150"
                      style={{ width: "100%", height: "100%" }}
                    ></canvas>
                    <button
                      type="button"
                      className="btn btn-danger mt-2"
                      style={{ position: "absolute", bottom: "-40px", right: "0" }}
                      onClick={() => {
                        const canvas = document.querySelector("canvas");
                        const ctx = canvas.getContext("2d");
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div> */}


              {/* Date */}
              {/* <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Date
                </label>
                <div className="col-md-9">
                  <input
                    type="date"
                    className="form-control shadow-sm"
                    required
                  />
                </div>
              </div> */}
             <div className="declaration-signature">
              <div className="form-check d-flex align-items-center">
                <input
                  className="form-check-input me-2"
                  type="checkbox"
                  id="acting_on_my_behalf"
                  name="acting_on_my_behalf"
                  checked={ClientData[0]?.acting_on_my_behalf}
                />
                <label className="form-check-label" htmlFor="acting_on_my_behalf">
                  I/We hereby confirm that I/we are acting and would, in future will
                  also be acting on my/our behalf for the purpose of transactions,
                  new accounts or providing any further information required by Blue
                  Aster Capital BSC ©.
                </label>
              </div>

              <div className="form-check d-flex align-items-center mt-2">
                <input
                  className="form-check-input me-2"
                  type="checkbox"
                  id="information_true"
                  name="information_true"
                  checked={ClientData[0]?.information_true}
                />
                <label className="form-check-label" htmlFor="information_true">
                  I/We hereby confirm the information provided above is true, accurate
                  and complete. Subject to applicable local laws, I/we hereby consent
                  for Blue Aster Capital BSC © or any of its affiliates to share our
                  information with domestic or overseas regulators or tax authorities
                  where necessary.
                </label>
              </div>

              <div className="form-check d-flex align-items-center mt-2">
                <input
                  className="form-check-input me-2"
                  type="checkbox"
                  id="notify_on_change"
                  name="notify_on_change"
                  checked={ClientData[0]?.notify_on_change}
                />
                <label className="form-check-label" htmlFor="notify_on_change">
                  I/We agree and undertake to notify Blue Aster Capital BSC © within
                  30 calendar days if there is a change in any information which I/we
                  have provided.
                </label>
              </div>

              <div className="form-group mt-3">
                <label htmlFor="name">Name / Authorised Signatory Name:</label>
                <input
                  type="text"
                  className="form-control"
                  id="signatory_name"
                  name="signatory_name"
                  placeholder="Enter your name"
                  value={ClientData[0]?.signatory_name}
                  readOnly
                />
              </div>

              <div className="form-group">
                <label htmlFor="signature">Digital Signature:</label><br />
                <img
                  src={signatureURL}
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="date">Date:</label>
                <input
                  type="date"
                  className="form-control"
                  id="declaration_date"
                  name="declaration_date"
                  value={formatDateToIST(ClientData[0]?.declaration_date)}
                  readOnly
                />
              </div>
            </div>

            </div>
          </fieldset>



      {/* Action buttons */}
      <div className="action-button-container" style={{textAlign:"center"}}>
        <button
          type="button"
          className="action-button-previous"
          onClick={handlePrevious}
          style={{ display: currentStep === 0 ? 'none' : 'block' }}
        >
          Previous
        </button>

        {/* Show "Next" or "Submit" based on the current step */}
        {currentStep === steps.length - 1 ? (
          <button
            type="button"
            className="action-button"
            onClick={handleSubmit} // Assuming handleSubmit handles form submission
          >
            Next
          </button>
        ) : (
          <button
            type="button"
            className="action-button"
            onClick={handleNext}
            style={{ display: currentStep === steps.length - 1 ? 'none' : 'block' }}
          >
            Next
          </button>
        )}
      </div>
      </Container>

    </div>
  );
};

export default MultiStepForm;
